export const LOADER_STATUS = 'boilderplate/GSTR3BCOMMON/LOADER_STATUS';
export const STORE_ENTITY = 'boilerplate/GSTR3BCOMMON/STORE_ENTITY';
export const STORE_GSTIN = 'boilerplate/GSTR3BCOMMON/STORE_GSTIN';
export const STORE_PERIOD = 'boilerplate/GSTR3BCOMMON/STORE_PERIOD';
export const CLEAR_DEFAULT_VALUE = 'boilerplate/GSTR3BCOMMON/CLEAR_DEFAULT_VALUE';
export const STORE_SINGLE_GSTIN = 'boilerplate/GSTR3BCOMMON/STORE_SINGLE_GSTIN';
